let React = require("react");

let ContentServerClient =  require("../../../ContentServerClient.js");

let WrappedModalHub     = require("./WrappedModalHub.jsx");
let Utilities           = require("../../../util/Utilities.js");

class UpdateModalHub extends React.Component {

    constructor(){
        super();

        this.deleteHub = this.deleteHub.bind(this);
        this.updateHub = this.updateHub.bind(this);
        this.checkSpecialCharacters = this.checkSpecialCharacters.bind(this);
    }

    componentWillReceiveProps(nextProps){
        this.name.value = nextProps.name;
        this.name.classList.remove("invalid")
    }

    shouldComponentUpdate(nextProps){
        return  this.props.id !== nextProps.id ||
                this.props.show !== nextProps.show ||
                this.props.memberCount !== nextProps.memberCount
    }

    updateHub(){
        let {id, memberCount, owner, onClose, setLoading, history, handleError} = this.props;
        if(this.name.value === "" || Utilities.hasSpecialCharacters(this.name.value)){return}

        setLoading(true, "Updating...");
        const name = this.name.value;
        ContentServerClient.updateHub(handleError, {id, name, memberCount, owner})
            .then(() => {
                onClose("update");
                setLoading(false);
                history.push(`/hubs/${id}-${encodeURIComponent(name)}/libraries`)
            })
            .catch(() => setLoading(false));
    }

    deleteHub(){
        let {id, onClose, history, setLoading, handleError} = this.props;

        setLoading(true, "Deleting...");

        ContentServerClient.deleteHub(handleError, id)
            .then(info => {
                setLoading(false);
                onClose("update");
                history.push("/start")
            })
            .catch(() => setLoading(false))
    }

    checkSpecialCharacters(){
        if(Utilities.hasSpecialCharacters(this.name.value)){
            this.name.classList.add("invalid")
        }else{
            this.name.classList.remove("invalid")
        }
    }

    render() {
        return  <WrappedModalHub show={this.props.show} style="fifty" title={`${fullHubAlias} Properties`}
                    btnBlue={{show: true, text: "Save", onClick: this.updateHub}}
                    customize={(this.props.totalHubsAllowed > 1) ? [{name: `Delete ${hubAlias}`, onClick: this.deleteHub, className:"delete transparent"}]: []}
                    onClose={() => this.props.onClose("update")}>
                    <div className="updateModalHub">
                        <div className="updateModalHub__contName">
                            <p className="bold">{hubAlias} Name:</p>
                            <input type="text" onChange={this.checkSpecialCharacters} ref={div => this.name = div}/>
                            <p className="warning">Special characters are not allowed.</p>
                        </div>
                    </div>
                </WrappedModalHub>
    }
}

module.exports = UpdateModalHub;
